import React from "react";
import DashboardLayout from "../../../Layout/DashboardLayout";
import Header from "./components/Header";
import AdminForm from "./components/AdminForm";

const CreateAdmin = () => {
  return (
    <DashboardLayout title="Admin Management" back={false}>
      <Header title="Create Admin" />
      <AdminForm />
    </DashboardLayout>
  );
};

export default CreateAdmin;
